import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import colors from 'common/styles/colors';

const TITLE_HEIGHT = 40;

const Frame = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
`;

export const OrgWidgetTitle = styled.div`
  color: ${colors.darkGray};
  font-weight: 600;
  width: 100%;
  padding: 1em 0 0 1em;
  height: ${TITLE_HEIGHT}px;
  flex-shrink: 0;
  box-sizing: border-box;
`;

const Body = styled.div`
  flex: 1;
  min-height: 0;
  overflow: hidden;
`;

function OrgWidgetFrame({ title, children }) {
  return (
    <Frame>
      {title ? <OrgWidgetTitle className="title">{title}</OrgWidgetTitle> : null}
      <Body>{children}</Body>
    </Frame>
  );
}

OrgWidgetFrame.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node.isRequired
};

OrgWidgetFrame.defaultProps = {
  title: null
};

export default OrgWidgetFrame;
